export enum CountryCodeWithBusinessUnit {
  AC_US = 'AC-US',
  AC_CA = 'AC-CA',
}
